import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  font-family: 'Segoe UI', sans-serif;
  background-color: #f9f9fb;
  min-height: 100vh;
`;

export const Sidebar = styled.div`
  width: 350px;
  background-color: white;
  padding: 2rem 1.5rem;
  box-shadow: 2px 0 5px rgba(0,0,0,0.05);

    @media (max-width: 1366px) {
    width: 280px;
  }
`;

export const SidebarHeader = styled.div`
  font-weight: bold;
  font-size: 0.95rem;
  color: #000;
  margin: 1.5rem 0 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
export const ToggleGroup = styled.ul`
  display: flex;
  border: 1px solid #ccc;
  border-radius: 999px;
  padding: 0;
  margin: 0;
  list-style: none;
  overflow: hidden;
  background: white;
`;

export const ToggleItem = styled.li<{ selected?: boolean }>`
  flex: 1;
  text-align: center;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-weight: ${({ selected }) => (selected ? 'bold' : 500)};
  color: ${({ selected }) => (selected ? '#2563eb' : '#6b7280')}; /* blue-600 vs gray-500 */
  background-color: ${({ selected }) => (selected ? '#bfdbfe' : 'white')}; /* light blue background */
  border-right: 1px solid #ccc;

  &:last-child {
    border-right: none;
  }

  &:first-child {
    border-top-left-radius: 999px;
    border-bottom-left-radius: 999px;
  }

  &:last-child {
    border-top-right-radius: 999px;
    border-bottom-right-radius: 999px;
  }
`;


export const SidebarList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const SidebarItem = styled.li<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: ${({ selected }) => (selected ? 'bold' : 500)};
  color: ${({ selected }) => (selected ? '#000' : '#8D8D8D')};
  margin-bottom: 0.7rem;
  cursor: pointer;

  &::before {
    content: ${({ selected }) => (selected ? "'•'" : "''")};
    color: black;
    font-size: 1.2rem;
    margin-right: 8px;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  padding: 2rem;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const DateLabel = styled.div`
  color: #767676;
  font-weight: 700;
`;

export const ViewType = styled.div`
  background: #f3f3f3;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-weight: 600;
`;



export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
  width: 100%;
  margin-bottom: 1rem;
  box-sizing: border-box;

  @media (max-width: 1370px) {
    grid-template-columns: repeat(4, minmax(215px, 1fr));x */
    padding: 0 1rem; 
    margin-left: -2.5rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 1900px) {
    grid-template-columns: repeat(4, minmax(250px, 1fr));
    gap: 2.5rem; 
  }
`;

export const Card = styled.div<{ color: string }>`
  background-color: ${({ color }) => color || '#9B5DE5'};
  border-radius: 1.25rem;
  padding: 0.8rem;
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 150px;
  overflow: hidden;
  flex-shrink: 1;

  @media (max-width: 1370px) {
    height: 150px;
  }
    
`;

export const CardTitle = styled.div`
  font-size: clamp(0.9rem, 1vw + 0.8rem, 1rem);
  font-weight: 600;
  margin-bottom: 0.15rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardCount = styled.div`
  font-size: clamp(1.8rem, 2vw + 1.5rem, 2.5rem);
  font-weight: bold;
  line-height: 1;
  margin: 0.2rem 0;
`;


export const CardIcons = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: auto; // Pushes to bottom

  @media (min-width: 1440px) {
    gap: 1.25rem;
  }

  @media (min-width: 1600px) {
    gap: 1.75rem;
  }

  @media (min-width: 1920px) {
    gap: 2.8rem;
  }
`;




export const IconButton = styled.button<{
  selected?: boolean;
  fontColor?: string;
  size?: 'compact' | 'default';
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ selected }) => (selected ? '#bfdbfe' : '#f1f5f9')};
  border: none;
  border-radius: 2rem;
  cursor: pointer;
  font-weight: bold;
  color: ${({ fontColor }) => fontColor || '#4b5563'};

  font-size: ${({ size }) => (size === 'compact' ? '16px' : '1rem')};
  padding: ${({ size }) => (size === 'compact' ? '4px 12px' : '0.5rem 0.75rem')};
  height: ${({ size }) => (size === 'compact' ? 'auto' : 'initial')};

  &:hover {
    background-color: #e0e7ff;
  }

  svg {
    font-size: 1.25rem;
    color: ${({ selected }) => (selected ? '#2563eb' : '#4b5563')};
  }
`;





export const DownloadButton = styled.button<{ selected?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ selected }) => selected || '#9B5DE5'};
  border: none;
  border-radius: 2rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    background-color: #e0e7ff;
  }

  svg {
    font-size: 1.25rem;
    color: ${({ selected }) => (selected ? '#2563eb' : '#4b5563')}; // blue-600 or gray-700
  }
`;




export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end; /* Pushes content to bottom */
  align-items: center;
  height: 100%; /* Fill available height */
  min-height: 200px; /* Optional minimum height */
  position: relative;
`;

export const ChartDateLabel = styled.div`
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
  color: #666;
  font-weight: 500;
`;

export const CardSubtext = styled.div`
  font-size: 19px;
  color: white;
  margin-top: 4px;
  text-align: center;
  font-weight: 1000;

  div {
    font-size: 12px;
    color: white;
    font-weight: bold;
  }
`;


export const CardCountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;






export const Bar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BarCount = styled.div<{ height: number; color: string }>`
  width: 100px;
  height: ${({ height }) => height * 200}px;
  background-color: ${({ color }) => color};
  
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-weight: bold;
  margin-bottom: 1.5px;
  span {
    color: #767676;
    font-weight: bold;
    margin-bottom: 4px;
  }
`;


export const BarCountText = styled.span`
color: #767676;
font-weight: bold;
`;

export const BarLabel = styled.div`
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #767676;
  font-weight: 700;
`;

export const ToggleOption = styled.button<{ active: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  background: ${({ active }) => (active ? '#4285F480' : 'transparent')};
  color: ${({ active }) => (active ? '#4367E9' : '#333333')};
  border: none;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: ${({ active }) => (active ? '#4285F480' : '#e6f0ff')};
  }
`;


export const ToggleSwitch = styled.div`
  display: flex;
  width: 90px;
  border-radius: 20px;
  overflow: hidden;
  background: #f0f0f0;
  font-size: inherit;
`;


export const ChartWrapper = styled.div`
  position: relative;
  margin-top: 200px;
  padding-bottom: 10px;
`;

export const ChartBars = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end; // This aligns the bars from the bottom
  position: relative;
  height: 200px; // Add a fixed height to define the chart's vertical space
`


export const ChartBaseline = styled.div`
  position: absolute;
  bottom: 40px; /* this positions the black line where bars start */
  left: 0;
  right: 0;
  height: 2px;
  background-color: black;
`;